import Marquee from "react-fast-marquee";
import { auth_reseller_list } from "../constants";
import { Icon } from "@iconify/react";
import PageFrames from "../ui/pageframes";

const AuthReseller = () => {
  return (
    <PageFrames>
      <div className="flex flex-col px-4 gap-2">
        <div className="flex flex-col md:flex-row items-center md:gap-4 text-[31px] text-center">
          <Icon icon="ic:baseline-sell" className="text-[#002F6C]" />
          <h1>Your Source for Certified Tech Solutions</h1>
        </div>
        <p className="accent-text text-center">
          Supplying only from brands we're officially authorized to represent.
        </p>
      </div>
      <Marquee className="bg-[#F2F2F2] py-4">
        {auth_reseller_list.map((src, idx) => (
          <img
            src={src}
            key={idx}
            alt="brands"
            className={
              src === "/images/auth-reseller/hp.webp"
                ? "w-16 mx-4 lg:mx-8"
                : "w-24 mx-4 lg:mx-8"
            }
          />
        ))}
      </Marquee>
    </PageFrames>
  );
};

export default AuthReseller;
